import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Navbar, Footer, Sidebar } from './components';
import { useStateContext } from './contexts/ContextProvider';
import AllRoutes from './AllRouter/Routes';
import AuthContextProvider from './contexts/MyContxt';

const App = () => {
  const {
    setCurrentColor,
    setCurrentMode,
    currentMode,
    activeMenu,
    currentColor,
    themeSettings,
    setThemeSettings,
  } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem('colorMode');
    const currentThemeMode = localStorage.getItem('themeMode');
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
      <BrowserRouter>
        <AuthContextProvider>
          <div className='flex relative dark:bg-main-dark-bg'>
            <div
              className='fixed right-4 bottom-4'
              style={{ zIndex: '1000' }}
            />
            {activeMenu ? (
              <div className='w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white '>
                <Sidebar />
              </div>
            ) : (
              <div className='w-0 dark:bg-secondary-dark-bg'>
                <Sidebar />
              </div>
            )}
            <div
              className={
                activeMenu
                  ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-72 w-full  '
                  : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 '
              }
            >
              <div className='fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full '>
                <Navbar />
              </div>
              <div>
                <AllRoutes />
              </div>
              <ToastContainer />
              <Footer />
            </div>
          </div>
        </AuthContextProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
